"use strict";
/*!
 *
 *  top-bg.js
 *
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var load_image_1 = __importDefault(require("load-image"));
var TopBg = /** @class */ (function () {
    function TopBg() {
        this.$contents = $('#Contents');
        this.$left = $('#ContentsBgLeft');
        this.$right = $('#ContentsBgRight');
        this.left = [
            '/img/top/bg_left_1.jpg',
            '/img/top/bg_left_2.jpg',
            '/img/top/bg_left_3.jpg'
        ];
        this.right = [
            '/img/top/bg_right_1.jpg',
            '/img/top/bg_right_2.jpg',
            '/img/top/bg_right_3.jpg'
        ];
        this.len = 2;
        this.max = this.left.length;
        this.setImg(this.$left, this.left);
        this.setImg(this.$right, this.right);
    }
    TopBg.prototype.setImg = function ($elem, dir) {
        var _this = this;
        var ran = Math.floor(Math.random() * (this.max));
        $elem.css('background-image', 'url(' + dir[ran] + ')');
        var img = load_image_1.default(dir[ran]);
        img.then(function () {
            if (--_this.len == 0) {
                _this.inited();
            }
            ;
        }, function () {
            console.log('fail');
        });
    };
    TopBg.prototype.inited = function () {
        this.$contents.addClass('tp-Contents-inited');
    };
    return TopBg;
}());
exports.default = TopBg;
